module.exports = __webpack_public_path__ + "d2c6b9cd669f45f4c5748c79e8087073.pdf";